import { render, staticRenderFns } from "./group-column-chart.vue?vue&type=template&id=28754062&"
import script from "./group-column-chart.vue?vue&type=script&lang=js&"
export * from "./group-column-chart.vue?vue&type=script&lang=js&"
import style0 from "./group-column-chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('28754062', component.options)
    } else {
      api.reload('28754062', component.options)
    }
    module.hot.accept("./group-column-chart.vue?vue&type=template&id=28754062&", function () {
      api.rerender('28754062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/group-column-chart.vue"
export default component.exports